<div class="sr-only" role="status" aria-live="assertive" aria-atomic="true">{{ statusMessage }}</div>
<zbp-zbchart-report-table
  reportLabel="Benchmark Skills Average Table"
  [showProgressReportsHelp]="false"
  [leftHeaderText]="benchmarkSkillsAverageReport?.entityViewType"
  rightHeaderText="Averages"
  [zbChart]="zbChart"
  [printableReportHeadings]="printableReportHeadings"
  [isPrinting]="isPrinting"
/>
<div class="styled-table-footer-container">
  <div class="styled-table-footer-left">
  </div>
  <div class="styled-table-footer-right">
    @if (collectionSize > pageSize && !isPrinting) {
      <nav class="styled-pagination">
        <ngb-pagination
          #pagination
          [pageSize]="pageSize"
          [maxSize]="maxPageCount"
          [collectionSize]="collectionSize"
          [page]="page"
          (pageChange)="onPageChange($event)"
        />
      </nav>
    }
  </div>
</div>
